<template>
<div>
    <a-dropdown :trigger='["click"]' :getPopupContainer="e => {return e.parentNode || document.body}">
      <div class="user-area-admin" @click="handleButtonClick">
        <!-- 用户头像 -->
        <div class="user-avatar">
            <img :src="userAvatar" alt="" srcset="" class="userImg" />
        </div>
        <!-- 用户名 -->
        <div v-if="!isMobile" class="user-name">{{ (userInfo && userInfo.userName) ? userInfo.userName : '登录/注册' }}</div>
        <!-- 箭头 -->
        <div v-if="!isMobile">
            <img :src="iconDown" alt="" srcset="" class="icon_down" />
        </div>
    </div>
      <a-menu slot="overlay" v-if="(userInfo && userInfo.userName)">
        <a-menu-item key="1" @click="handleClick">
            <div class="account_item">
                <img :src='msg_icon' class="icon_img" alt="" srcset="" />
                <img :src='msg_icon_active' class="icon_img hiden" alt="" srcset="" />
                <div class="item_text">用户反馈</div>
            </div>
        </a-menu-item>
        <a-menu-item key="2" @click="goSet">
            <div class="account_item">
                <img :src='set_icon' class="icon_img" alt="" srcset="" />
                <img :src='set_icon_active' class="icon_img hiden" alt="" srcset="" />
                <div class="item_text">设置</div>
            </div>
        </a-menu-item>
        <a-menu-item key="3" @click="loginOut">
            <div class="account_item">
                <img :src='out_icon' class="icon_img" alt="" srcset="" />
                <img :src='out_icon_active' class="icon_img hiden" alt="" srcset="" />
                <div class="item_text out_text">退出登录</div>
            </div>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <UserFeedback :visible.sync='feedbackVisible'></UserFeedback>
</div>  
</template>

<script>
import userAvatar from '@/assets/user-avatar.png'
import iconDown from '@/assets/icon_down.png'
import msg_icon from '@/assets/msg_icon.png'
import msg_icon_active from '@/assets/msg_icon_active.png'
import set_icon from '@/assets/set_icon.png'
import set_icon_active from '@/assets/set_icon_active.png'
import out_icon from '@/assets/out_icon.png'
import out_icon_active from '@/assets/out_icon_active.png'
import UserFeedback from '@/components/UserFeedback'
import { mapActions,mapState } from 'vuex'
export default {
    components:{
        UserFeedback
    },
    data() {
        return {
            userAvatar,
            iconDown,
            msg_icon,
            msg_icon_active,
            set_icon,
            set_icon_active,
            out_icon,
            out_icon_active,
            feedbackVisible:false,
            userName:''
        }
    },
    computed:{
        ...mapState('user',['userInfo']),
        ...mapState('mobile',['isMobile']),
    },
    created() {
        if(localStorage.getItem('web_login_token')){
            this.setUserInfo()
        }
    },
    methods:{
        ...mapActions("user", ["setUserInfo","clearUserInfo"]),
        handleClick(){
            this.feedbackVisible = true
            this.$emit('drawerChange')
        },
        goSet(){
           this.$router.push('/setting') 
           this.$emit('drawerChange')
        },
        loginOut(){
            this.$confirm({
                title: '退出登录',
                content: '退出登录不会丢失任何数据，你仍可以随时登录本账号。',
                okText: '确 定',
                okType: 'danger',
                cancelText: '取 消',
                onOk:() => {
                    localStorage.removeItem('web_login_token')
                    setTimeout(() => {
                        sessionStorage.removeItem('store')
                    }, 1000);
                    this.clearUserInfo()
                    this.$router.replace('/login')
                    this.$emit('drawerChange')
                },
            });
        },
        handleButtonClick(){
            if(!localStorage.getItem('web_login_token')){
                this.$router.push('/login')
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.account_item:hover{
    .hiden{
        display: inline-block !important;
    }
    .icon_img{
        display: none;
    }
    .item_text{
        color: $base_color;
    }
    .out_text{
        color: #FF3B30;
    }
}
.ant-dropdown-menu-item:hover, 
.ant-dropdown-menu-submenu-title:hover{
    background: #fff !important;
}
.account_item{
    display: flex;
    align-items: center;
    padding: 5px 0;
    .hiden{
        display: none;
    }
    .icon_img{
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }
    .item_text{
        font-size: 14px;
        color: #666666;
        line-height: 19px;
    }
}
.user-area-admin{
    padding: 6px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    .icon_down{
        width: 16px;
        height: 16px;
    }
    .user-name{
        flex: 1;
        margin: 0 8px;
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow:ellipsis;
    }
    .userImg{
        width: 28px;
        height: 28px;
    }
}
.user-area-admin:hover{
    background: rgba(1,10,28,0.05);
    border-radius: 8px;
}
</style>